import React, { useEffect, useState } from 'react'
import "./Login.css";
import request from "../Apis/request";
import { useNavigate } from 'react-router';
import axios from "axios";
import Select from 'react-select';
import { firebase_app, Jwt_token } from '../Config/Config';
import man from '../assets/images/dashboard/1.png';
import Swal from "sweetalert2";
import { GpsBaseURL, uniqueToken } from '../api/DataApis';
import SBILogo from "../assets/images/bob_logo.png";
import { fetchLoginApi } from '../Apis/Login';
import { fetchRegisterApi } from '../Apis/Login';
import { fetchOtpVerificationApi } from '../Apis/Setting';
import { getCountryList, getStateList, getCityList } from '../Apis/Setting';
import { getCorporateList } from '../Apis/Setting';
import Loader from '../Modules/Settings/Loader';
import backIcon from '../assets/images/back-arrow.png';
import { getUserInfo } from '../Apis/Setting';
import FooterClass from '../Layout/Footer';


const Signin = () => {
  
  const [value, setValue] = useState(
    localStorage.getItem('profileURL' || man)
  );
  const [name, setName] = useState(
    localStorage.getItem('Name')
  );

  const [isLogin, setIsLogin] = useState(true);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [Name, setNames] = useState("");
  const [PinCode, setPincode] = useState("");
  const [Email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [Country, setCountry] = useState(null);
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [District, setDistrict] = useState("");
  const [BCAgentID, setBCAgentID] = useState("");
  const [BCCorporateID, setBCCorporateID] = useState("");
  const [companies, setCompanies] = useState([]);
  const [CorporateID, setCorporateID] = useState("");
  const [password, setPassword] = useState('');
  const [usertype, setusertype] = useState('');
  const [countriesList, setcountriesList] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [cityList, setcityList] = useState([]);
  const [corporateList, setCorporateList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [isresend, setisresend] = useState(false);
  const [istermscond, setistermscond] = useState(false);
  const handleMobileNumberChange = (e) => setMobileNumber(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleUsertypeChange = (e) => setusertype(e.target.value);
  const handleCheckboxChange = (event) => {setistermscond(event.target.checked);};
  const [BCCorporateName, setBCCorporateName] = useState("");
  const [errors, setErrors] = useState({});
  
  //console.log("BCCorporateID", BCCorporateID);
  const userID = localStorage.getItem("userID");

  const history = useNavigate();
  console.log("cityListttt", cityList);

  useEffect(() => {
  const fetchCompanies = async () => {
      try {
        const res = await axios.get(`${GpsBaseURL}/web/setting/companies`);
        const options = res.data?.data?.map((item) => ({
          value: item._id,
          label: item.company_name,
        }));
        setCompanies(options);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, []);


  const handleLogin = async (event, isResend = false) => {
    event.preventDefault(); // Prevent page reload

    // Validate Mobile Number
    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: !mobileNumber
          ? "Please enter a mobile number."
          : "Please enter a valid 10-digit mobile number.",
        showConfirmButton: true,
      });
      return;
    }

    setLoadingLogin(true);

    try {
      if (isLogin) {
        // ✅ Login Flow
        const response = await fetchLoginApi(mobileNumber);

        if (response?.statusCode === 200) {
          if (isResend) {

            Swal.fire({
              icon: "success",
              title: "success",
              text: response?.message || "Please try again.",
              showConfirmButton: false,
              timer: 1000
            });
          }
          // localStorage.setItem("authToken", response.data.token);
          // localStorage.setItem("token", response.data.token);
          setShowOtpPopup(true); // ✅ Show OTP Popup

        } else {
          Swal.fire({
            icon: "error",
            title: "Login Failed",
            text: response?.data?.message || "Please try again.",
            showConfirmButton: true,
          });
        }
      } else {

        if (!istermscond) {
          Swal.fire({
              icon: "warning",
              title: "Please Accept Terms & Conditions",
              text: "You must accept the Terms & Conditions before signing up.",
              showConfirmButton: true,
          });
          return;
      }

      if( PinCode && Address) {
        
        const { isConfirmed } = await Swal.fire({
          title: "Confirm Pin Code",
          text: "Please check your pin code and ensure it is correctly added in the address.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, it's correct",
          cancelButtonText: "Cancel",
        });

        // Step 2: If user cancels, stop here
        if (!isConfirmed) {
          return;
        }
      }

      //console.log("--BCCorporateName--", BCCorporateName);
        // ✅ Signup Flow
        const userData = {
          name: Name,
          email: Email,
          mobile: mobileNumber,
          address: Address,
          country: Country,
          state: state,
          city: city,
          district: District,
          pin_code: PinCode,
          bc_agent_id: BCAgentID,
          corporate_id: CorporateID,
          company_id: BCCorporateID,
          bc_corporate_name:BCCorporateName
        };

      

        const response = await fetchRegisterApi(userData, userID);
        console.log("Signup Response:", response);

        if (response?.statusCode === 200) {

          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem("token", response.data.token);

          localStorage.setItem(
            "userData",
            JSON.stringify({
              name: Name,
              email: Email,
              mobile: mobileNumber,
            })
          );

          window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
          setShowOtpPopup(true);
        }
        else {
          Swal.fire({
            icon: "error",
            title: response?.message,

            showConfirmButton: true,
          });
        }
        setLoadingLogin(false);

      }
    }


    catch (error) {

      console.error("Error:", error);

      // Extract and format error messages
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data) {
        const errorData = error.response.data;

        // Convert array of messages into a list format
        if (Array.isArray(errorData.message)) {
          errorMessage = errorData.message.map((msg) => `• ${msg}`).join("\n");
        } else {
          errorMessage = errorData.message || errorMessage;
        }
      }

      // Show all errors in Swal pop-up
      Swal.fire({
        icon: "error",
        title: "Error!",
        html: `<pre style="text-align:left;">${errorMessage}</pre>`, // Keeps formatting for multiple lines
        showConfirmButton: true,
      });
    } finally {
      setLoadingLogin(false);
    }
  };


  useEffect(() => {
    console.log("hellllllllllo");
    const token = localStorage.getItem("authToken");

    if (token) {
      // Redirect to dashboard if token exists
      window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
    }
  }, []);



  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const data = {
      "otp": otp,
      "mobile": mobileNumber
    }

    if (!otp) {
      alert("Please enter the OTP.");
      return;
    }

    setLoadingOtp(true);

    try {
      setLoading(true);
      const response = await fetchOtpVerificationApi(data); // Call OTP verification API
      fetchUserList();

      console.log("Login Response:", response);
      localStorage.setItem("otpverificationData", response.data?.show_corporate_message);
      setLoading(false);
      if (response?.statusCode === 200) {
        if( response?.data?.is_form_flag ) {
          localStorage.setItem("authToken", response.data.token);
          localStorage.setItem("token", response.data.token);
        }
        localStorage.setItem("isformFlag",response?.data?.is_form_flag);
        localStorage.setItem("userID", response?.data?._id);
        //localStorage.setItem("userData", {name:response?.data?.name, email:response?.data?.email, mobile:response?.data?.mobile});
        localStorage.setItem(
          "userData",
          JSON.stringify({
            name: response?.data?.name,
            email: response?.data?.email,
            mobile: response?.data?.mobile,
          })
        );

        fetchCorporatesList();
        fetchUserList();
        if(response.data?.show_corporate_message === true) {
          window.location.href =  `${process.env.PUBLIC_URL}/dashboard/index`;
        }
        // ✅ Check corporate_id properly
       else  if (response?.data?.is_form_flag) {
           window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
        } else {
          // alert("No corporate ID found. Redirecting to signup...");
          setIsLogin(!isLogin);
        }
      } else {
        alert("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Login failed. Please try again.");
    } finally {
      setLoadingOtp(false); // ✅ Ensure loading state is reset
      setLoading(false);
    }
  };

  const fetchUserList = async () => {
    setLoading(true);

    try {
      const userData = await getUserInfo(userID);
      console.log("userData", userData?.data);
      setUserData(userData?.data);
    } catch (error) {
      console.error("Error fetching user list:", error);
    } finally {
      setLoading(false); // Ensures loading is set to false even if an error occurs
    }
  };

  // setStatusListing(res.data);
  useEffect(() => {
    fetchUserList();
  }, [userID]);
  useEffect(() => {
    setLoading(true);
    if (UserData) {
      setNames(UserData?.name || "");

      setEmail(UserData?.email || "");
      setMobileNumber(UserData?.mobile || "")
      // setOriginalMobileNumber(UserData?.mobile || "");
      setPincode(UserData?.pin_code);
      setDistrict(UserData?.district);
      if (UserData?.corporate_id) {
        setCorporateID(UserData?.corporate_id[0] || [])
      }
      setBCAgentID(UserData?.bc_agent_id || "");
      setBCCorporateID(UserData?.company_id || "");
      setBCCorporateName(UserData?.bc_corporate_name || "");
      setAddress(UserData?.address);
      if (UserData?.countryId) {
        const countryId = UserData.countryId[0] || "";

        // Find the country in `countriesList` based on `_id`
        const matchedCountry = countriesList?.find((c) => c._id === countryId);

        setCountry({
          id: matchedCountry?.id || "",  // Get `id` from `countriesList`
          _id: countryId                  // Use `_id` from `UserData`
        });
      }
      if (UserData?.stateId) {
        const stateId = UserData.stateId[0] || "";
        const matchedState = stateList?.find((c) => c._id === stateId);
        console.log("matchedState", matchedState);
        setState({
          id: matchedState?.id,
          _id: stateId || ""
        })
      }
      if (UserData?.cityId) {
        setCity(UserData?.cityId[0] || "")
      }
      // Set loading to false once data is loaded
      setLoading(false);
    }
  }, [UserData, countriesList]);
  console.log("country", Country);
  console.log("userData", UserData);

  const fetchCorporatesList = async () => {
    try {
      const corporatesData = await getCorporateList();
      console.log("corporateData", corporatesData);
      setCorporateList(corporatesData?.data || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  useEffect(() => {
    fetchCorporatesList();
  }, [uniqueToken]);
  console.log("corporateList", corporateList);

  const fetchCountriesList = async () => {

    try {
      const countriesData = await getCountryList();
      console.log("countriesData", countriesData?.data);
      setcountriesList(countriesData?.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  // setStatusListing(res.data);
  useEffect(() => {
    fetchCountriesList();
  }, []);

  const fetchStateList = async () => {
    if (!Country?.id) {
      console.log("Country ID is missing, cannot fetch state.");
      return;
    }
    try {
      const stateData = await getStateList(Country?.id || []);
      setstateList(stateData?.data?.data || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  // setStatusListing(res.data);
  useEffect(() => {
    fetchStateList();
  }, [Country]);



  const fetchCityList = async () => {
    if (!state?.id) {
      console.log("State ID is missing, cannot fetch cities.");
      return;
    }

    try {
      const cityData = await getCityList(state?.id);
      console.log("cityData-testing", cityData);
      setcityList(cityData?.data?.data || []);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  // setStatusListing(res.data);
  useEffect(() => {
    if (state?.id) {
      fetchCityList();
    }
  }, [state]);



  const handlecountryChange = (e) => {
    const selectedCountryId = e.target.value;
    const selectedCountry = countriesList.find((c) => c._id === selectedCountryId);
    setCountry(selectedCountry); // ✅ Store the entire country object
  };
  const handlestateChange = (e) => {

    const selectedStateId = e.target.value;
    const selectedState = stateList?.find((c) => c._id === selectedStateId);
    setState(selectedState); // ✅ Store the entire country object

    // Store the object in state

  };

  console.log("state", state)

  // useEffect(() => {
  //   const token = localStorage.getItem("uniqueToken");
  //   if (token) {
  //     // Redirect to dashboard if token exists
  //     window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
  //   }
  // }, []);


  return (
    <>

      {/* <div className="logo-container">
      <img
        className="profile-image rounded-circle mb-4"
        src={SBILogo}
        alt="Profile"
        style={{
          width: '150px',
          height: '150px',
          objectFit: 'cover',
          border: '3px solid #ddd',
        }}
      /> 
    </div> */}
      <div className="logo-wrap">
        <form className="login-form12 login-box d-flex align-items-center">
          <div className='login-left'>
            {/* {loadingLogin && (
              <>
                <Loader />
              </>
            )} */}
            {isLogin &&
              <div className="container123">
                <h2 className="login-title mb-4">
                  {isLogin && showOtpPopup ? (
                    <>
                      <button type='button' className='signin-back-btn' onClick={() => setShowOtpPopup(false)}>
                        <img src={backIcon} />
                      </button>
                      Enter OTP
                    </>
                  ) : "Sign In With Mobile"}
                </h2>
                {isLogin && showOtpPopup ? (
                  <>
                    <div className="form-group d-block">
                      <label htmlFor="email">OTP</label>
                      <input
                        className='form-control'
                        type="number"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        style={{ appearance: "textfield" }}
                      />
                    </div>

                    <div className="form-group d-block mb-4">
                      <button className="resend-otp-btn w-100" type="button" onClick={(e) => handleLogin(e, true)} value="Send OTP">
                        {loadingLogin ?
                          <div className="spinner-border text-primary btn-spinner" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          : "Resend OTP"}

                      </button>
                    </div>

                    <button
                      onClick={handleOtpSubmit}
                      type="submit"
                      className='btn btn--form w-100'
                    >
                      {loadingOtp ?
                        <div className="spinner-border text-primary btn-spinner" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        : "Submit OTP"}
                    </button>
                  </>
                ) :
                  (
                    <>
                      <div className='form-group d-block mb-3'>
                        <label htmlFor="email">Mobile Number</label>
                        <input
                          className='form-control'
                          id="text"
                          type="text"
                          placeholder="Enter Mobile Number"
                          name="text"
                          value={mobileNumber}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only numbers and restrict to 10 digits while allowing editing
                            if (/^\d{0,10}$/.test(value)) {
                              setMobileNumber(value);
                            }
                          }}
                        />
                      </div>
                      <div className='custom-checkbox mb-4'>
                        <input
                          type="checkbox"
                          defaultValue="lsRememberMe"
                          className="rememberMe styled-checkbox"
                          id="rememberMe"
                        />
                        <label htmlFor="rememberMe">Remember me</label>
                      </div>
                      <button className="btn btn--form w-100" type="submit" onClick={(e) => handleLogin(e, false)} disabled={loadingLogin}>
                        {loadingLogin ? (
                          <>
                            <span className="spinner-border me-2" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : (
                          "Send OTP"
                        )} 
                      </button> 

                    </>
                  )}
              </div>
            }
            {!isLogin && (
              <div className="signup-container">
                <form className="signup-form">
                  <h2 className="login-title mb-4">Create an Account</h2>
                  <div className='row'>
                    <div className="col-12 form-group">
                      <label htmlFor="fullName">Full Name<span style={{ color: "red" }}>*</span></label>
                      <input className='form-control' type="text" id="fullName" value={Name} placeholder="Enter your full name" onChange={(e) => setNames(e.target.value)} />
                    </div>

                    <div className="col-12 form-group">
                      <label htmlFor="email">Email<span style={{ color: "red" }}>*</span></label>
                      <input className='form-control' type="email" id="email" value={Email} placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    <div className='col-12 form-group'>
                      <label htmlFor="email">Mobile Number</label>
                      <input
                        className='form-control'
                        id="text"
                        type="text"
                        placeholder="Enter Mobile Number"
                        name="text"
                        value={mobileNumber}
                        onChange={handleMobileNumberChange}
                        disabled={true}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <label htmlFor="pinCode">Pin Code<span style={{ color: "red" }}>*</span></label>
                      <input className='form-control' type="number" id="pinCode" value={PinCode} placeholder="Enter your pin code" onChange={(e) => setPincode(e.target.value)} />
                    </div>

                    <div className="col-12 form-group">
                      <label htmlFor="corporate">Corporate<span style={{ color: "red" }}>*</span></label>
                      <select className='form-control' id="corporate" value={CorporateID} onChange={(e) => setCorporateID(e.target.value)} >
                        <option value="">Select Corporate</option>
                        {corporateList.map((u) => (
                          <option key={u._id} value={u._id}>{u.corporate_name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12 form-group">
                      <label htmlFor="country">Country<span style={{ color: "red" }}>*</span></label>
                      <select
                        className="form-control"
                        id="country"
                        value={Country?._id || ""} // ✅ Ensure value is an `_id`
                        onChange={handlecountryChange}
                      >
                        <option value="">Select Country</option>
                        {countriesList?.map((u) => (
                          <option key={u._id} value={u._id}>
                            {u.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 form-group">
                      <label htmlFor="state">State<span style={{ color: "red" }}>*</span></label>
                      <select className='form-control' id="corporate" value={state?._id} onChange={handlestateChange}>
                        <option value="">Select State</option>
                        {stateList?.map((u) => (
                          <option key={u._id} value={u._id}>
                            {u.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 form-group">
                      <label htmlFor="city">City<span style={{ color: "red" }}>*</span></label>
                      <select className='form-control' id="city" value={city} onChange={(e) => setCity(e.target.value)} >
                        <option value="">Select City</option>
                        {cityList?.map((u) => (
                          <option key={u._id} value={u._id}>{u.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 form-group">
                      <label htmlFor="city">District<span style={{ color: "red" }}>*</span></label>
                      <input type="text" className='form-control' id="district" value={District} placeholder="Enter Your District" onChange={(e) => setDistrict(e.target.value)} />



                    </div>

                    <div className="col-12 form-group">
                      <label htmlFor="bcAgentID">BC Agent ID<span style={{ color: "red" }}>*</span></label>
                      <input className='form-control' type="text" id="bcAgentID" value={BCAgentID} placeholder="Enter BC Agent ID" onChange={(e) => setBCAgentID(e.target.value)} />
                    </div>
                    {/* <div className="col-12 form-group">
                      <label htmlFor="bcAgentID">BC Corporate Name<span style={{ color: "red" }}>*</span></label>
                      <input className='form-control' type="text" id="bcAgentID" value={BCCorporateID} placeholder="Enter BC Corporate ID" onChange={(e) => setBCCorporateID(e.target.value)} />
                    </div> */}
                    <div className="col-12 form-group">
                      <label htmlFor="bcAgentID">
                        BC Corporate Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        id="bcAgentID"
                        className="form-control"
                        options={companies}
                        value={companies.find(c => c.value === BCCorporateID)}
                        onChange={(selected) => setBCCorporateID(selected?.value)}
                        placeholder="Select BC Corporate"
                        isClearable
                      />
                    </div>
                    {/* ✅ Show input only if 'Other' is selected */}
                    {BCCorporateID === "686040c4ec7443e4d4d9348f" && (
                      <div className="col-12 form-group">
                        <label htmlFor="customCorporateName">Enter BC Corporate Name</label>
                        <input
                          type="text"
                          id="customCorporateName"
                          className="form-control"
                          placeholder="Enter BC Corporate Name"
                          value={BCCorporateName}
                          onChange={(e) => setBCCorporateName(e.target.value)}
                        />
                      </div>
                    )}

                    <div className="col-12 form-group mb-4">
                      <label htmlFor="address">Address<span style={{ color: "red" }}>*</span></label>
                      <textarea className='form-control text-start' id="address" placeholder="Enter your address" value={Address} onChange={(e) => setAddress(e.target.value)} />
                    </div>
                    <div className="col-md-6 col-12 form-group">
                      <div className='custom-checkbox'>
                        <input type="checkbox" id="rememberMe"  checked={istermscond} 
        onChange={handleCheckboxChange}  className='styled-checkbox' />
                    <label htmlFor="rememberMe">
  <a 
    href="https://your-terms-and-conditions-link.com" // Replace with your actual URL
    target="_blank" 
    rel="noopener noreferrer" 
    style={{ color: "red", textDecoration: "underline", cursor: "pointer" }}
  >
    Terms and Conditions Apply (Mandatory)
  </a>
</label>

                      </div>
                    </div>
                  </div>
                  <button onClick={handleLogin} className="btn btn--form w-100" disabled={loadingLogin}>
                    {loadingLogin ? (
                      <>
                        <span className="spinner-border  me-2" style={{ width: "1.2rem", height: "1.2rem", borderWidth: "0.15rem", verticalAlign: "-4px" }} role="status"></span>
                        Signing Up...
                      </>
                    ) : (
                      "Sign Up"
                    )}
                  </button>

                </form>
              </div>
            )}
          </div>
          <div className='login-right'>
            <div className='w-100 px-5'>
              <div className='text-4xl font-bold mb-3 text-white'>Track Your Assets with Confidence</div>
              <p className='text-lg mb-3 text-white'>Welcome to Raivens Technologies' GPS tracking solution. Our advanced devices help you monitor and protect your valuable assets in real-time.</p>
              <ul className='space-y-2 text-white'>
                <li>✓ Real-time tracking</li>
                <li>✓ Easy installation</li>
                <li>✓ 24/7 support</li>
                <li>✓ Nationwide coverage</li>
              </ul>
            </div>
          </div>
        </form>
      </div>
      {/* <FooterClass/> */}
    </>

  )
}
export default Signin;